var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolicitud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26464",
    "data-name": "Rect\\xE1ngulo 26464",
    width: 9.934,
    height: 13,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "descargar_solicitud",
    "data-name": "descargar solicitud",
    transform: "translate(1314.459 -8061.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24800",
    "data-name": "Trazado 24800",
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.514,12.514,0,0,1,12.5,25m0-23.809A11.309,11.309,0,1,0,23.808,12.5,11.321,11.321,0,0,0,12.5,1.191",
    transform: "translate(-1314.459 8061.305)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23403",
    "data-name": "Grupo 23403",
    transform: "translate(-1306.459 8067.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23402",
    "data-name": "Grupo 23402",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25766",
    "data-name": "Trazado 25766",
    d: "M30.609,106.1H28.551a.455.455,0,0,0,0,.91h2.059a.455.455,0,1,0,0-.91",
    transform: "translate(-25.54 -96.45)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25767",
    "data-name": "Trazado 25767",
    d: "M32.516,80.169H28.551a.455.455,0,1,0,0,.91h3.965a.455.455,0,1,0,0-.91",
    transform: "translate(-25.54 -72.877)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25768",
    "data-name": "Trazado 25768",
    d: "M32.516,54.442H28.551a.455.455,0,1,0,0,.91h3.965a.455.455,0,1,0,0-.91",
    transform: "translate(-25.54 -49.49)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25769",
    "data-name": "Trazado 25769",
    d: "M9.8,3.032,6.872.132C6.865.125,6.857.12,6.849.113A.436.436,0,0,0,6.8.077h0C6.792.068,6.78.064,6.769.058A.439.439,0,0,0,6.726.035h0A.451.451,0,0,0,6.68.021c-.013,0-.026-.009-.039-.012h0A.453.453,0,0,0,6.56,0H.455A.455.455,0,0,0,0,.455v12.09A.455.455,0,0,0,.455,13H9.479a.455.455,0,0,0,.455-.455V3.355A.455.455,0,0,0,9.8,3.032M7.006,1.553,8.381,2.927H7.006ZM.91,12.09V.91H6.1V3.382a.455.455,0,0,0,.455.455H9.024V12.09Z",
    fill: "#d5007f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitud);
export default __webpack_public_path__ + "static/media/Solicitud.061f005e2d1464982e7c228b039ca67c.svg";
export { ForwardRef as ReactComponent };